import { Button } from '../../components/UI-CHAKRA/Button';
import { Box } from '../../components/UI-CHAKRA/Box';
import colorContrast from 'color-contrast';
import rightArrow from '../../assets/images/icons/right-arrow.svg';
import { ReactSVG } from 'react-svg';
import { ChevronLeftIcon } from '@chakra-ui/icons';
import { Flex } from '../../components/UI-CHAKRA/Flex';
import { useMyCentralStore } from '../../stores/myCentralStore';
import { useDrawerStore } from '../../stores/drawerStore';

export interface PrescriptionFooterProps {
  onCancel?(): void;
  onContinue(): void;
  continueLabel: string;
  loading: boolean;
  continueDisabled?: boolean;
  cancelDisabled?: boolean;
  cancelLabel: string;
}

export default function PrescriptionFooter(props: PrescriptionFooterProps) {
  const sideBarWidth = useMyCentralStore((state) => state.sideBarWidth);
  const { drawerOpen } = useDrawerStore();

  const onContinue = () => {
    if (props.loading) return;
    props.onContinue();
  };

  const continueButtonWidth = props.loading ? '50px' : 'auto';

  if (drawerOpen) return null;

  return (
    <Flex
      position={'fixed'}
      justifyContent={{ base: 'space-around', md: 'flex-end' }}
      alignItems={'flex-end'}
      bottom={'0px'}
      right={{ base: 0, md: sideBarWidth }}
      w={'fit'}
      bg={'linear-gradient(0deg, rgba(248, 249, 250, 0.70) 50%, rgba(248, 249, 250, 0.00) 100%)'}
      h={'120px'}
      paddingBottom={{ base: '15px', md: '20px' }}
      paddingRight={{ base: 0, md: '25px' }}
      gap={'10px'}
      transition={'right 0.3s ease'}
      zIndex={10}
      pointerEvents={'none'}
    >
      <Box width={'140px'}>
        {props.continueLabel !== 'OK' && !!props.onCancel && (
          <Button
            height={'41px'}
            onClick={props.onCancel}
            isDisabled={props.cancelDisabled}
            borderRadius={'20px'}
            borderWidth={'2px'}
            w={'140px'}
            display={'flex'}
            justifyContent={'space-between'}
            fontWeight={700}
            variant={'outline'}
            color={colorContrast('#fff', '#fff700') > 3 ? 'white' : '#1E252B'}
            pointerEvents={'auto'}
          >
            <ChevronLeftIcon w={'24px'} h={'24px'} />
            {props.cancelLabel}
          </Button>
        )}
      </Box>

      <Box display={'flex'} justifyContent={'flex-end'}>
        {props.continueLabel !== '' && (
          <Button
            data-cy={'continue'}
            height={'41px'}
            w={continueButtonWidth}
            borderRadius={'20px'}
            display={'flex'}
            justifyContent={'space-between'}
            fontWeight={700}
            variant={'solid'}
            onClick={onContinue}
            isDisabled={props.continueDisabled || props.loading}
            isLoading={props.loading}
            _loading={{
              justifyContent: 'center',
            }}
            _disabled={{}}
            transition={'all 0.6s ease'}
            gap="10px"
            minWidth={'140px'}
            pointerEvents={'auto'}
            data-testid="autorize-button"
          >
            {props.continueLabel}
            {!props.loading && props.continueLabel !== 'OK' && <ReactSVG src={rightArrow} />}
          </Button>
        )}
      </Box>
    </Flex>
  );
}
